import CryptoJS from 'crypto-js'

/**
 * AES 加密
 * @param word: 需要加密的文本
 * KEY: // 需要前后端保持一致
 * mode: CBC // 需要前后端保持一致
 * pad: Pkcs7 //前端 Pkcs7 对应 后端 Pkcs5
 */
const KEY = CryptoJS.enc.Utf8.parse('B8E2C40A7D9A7F671A86B4E57C9D12D1');
const iv = CryptoJS.enc.Utf8.parse('5F4A3D2C1B0A9E8F');

export const AES_Encrypt = (plaintext) => {

  let encrypted = CryptoJS.AES.encrypt(plaintext, KEY, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
  return encrypted
}

/**
 * AES 解密
 * @param jsonStr
 */
export const AES_Decrypt = (jsonStr) => {
  var date:any = new Date();
  var timestamp:number = Math.round(date / 1000);

  let plaintext = CryptoJS.AES.decrypt(jsonStr, KEY, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString(CryptoJS.enc.Utf8)

  return plaintext
}

export function getTimeStr(timestamp) {
  const now:any = new Date();
  const date:any = new Date(timestamp);
  const diff = (now - date) / 1000; // 毫秒转换为秒

  if (diff < 60) {
    return " just ";
  } else if (diff < 3600) {
    return Math.floor(diff / 60) + " minute ";
  } else if (diff < 86400) {
    return Math.floor(diff / 3600) + " Hour ";
  } else if (diff < 604800) {
    return Math.floor(diff / 86400) + " day ";
  } else if (diff < 4322600) {
    return Math.floor(diff / 604800) + " week ";
  } else {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
  }
}

